import { Heading, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import {
  useTextVariants,
  useSectionHeadingVariant,
} from "@/theme/components/useSectionHeading";
import ReviewCard from "./reviewCard";
import { REVIEW_CONSTANTS } from "./constants";

const CustomerReviewComponent = () => {
  const HeadingVariant = useSectionHeadingVariant();
  const { title, desc, list } = REVIEW_CONSTANTS;
  const textVariant = useTextVariants();
  return (
    <Stack spacing={8}>
      <Stack spacing={4}>
        <Heading as="h2" variant={HeadingVariant} textAlign={"center"}>
          {title}
        </Heading>
        <Text variant={textVariant} color={"text.100"} textAlign={"center"}>
          {desc}
        </Text>
      </Stack>
      <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={{ base: 8, sm: 12, "2xl": 16 }}>
        {list.map((item, index) => (
          <ReviewCard key={index} {...item} />
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default CustomerReviewComponent;
